/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Station,
    StationFromJSON,
    StationToJSON,
    StationListBusinessDataResponse,
    StationListBusinessDataResponseFromJSON,
    StationListBusinessDataResponseToJSON,
    StationsControllerConfiguration,
    StationsControllerConfigurationFromJSON,
    StationsControllerConfigurationToJSON,
    UploadStationsResponse,
    UploadStationsResponseFromJSON,
    UploadStationsResponseToJSON,
    ValidationErrors,
    ValidationErrorsFromJSON,
    ValidationErrorsToJSON,
} from '../models';

export interface ApiStationsApiStationsGetByIataCodeIataGetRequest {
    iata: string;
}

export interface ApiStationsGetAllStationsGetRequest {
    pageNumber?: number;
    pageSize?: number;
    iataCode?: string;
    name?: string;
    locationCode?: string;
}

export interface ApiStationsIdGetRequest {
    id: string;
}

export interface ApiStationsPatchRequest {
    station?: Station;
}

export interface ApiStationsPostRequest {
    station?: Station;
}

export interface ApiStationsValidatePostRequest {
    station?: Station;
}

/**
 * no description
 */
export class StationsApi extends runtime.BaseAPI {

    /**
     */
    async apiStationsApiStationsGetByIataCodeIataGetRaw(requestParameters: ApiStationsApiStationsGetByIataCodeIataGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.iata === null || requestParameters.iata === undefined) {
            throw new runtime.RequiredError('iata','Required parameter requestParameters.iata was null or undefined when calling apiStationsApiStationsGetByIataCodeIataGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations/api/Stations/GetByIataCode/{iata}`.replace(`{${"iata"}}`, encodeURIComponent(String(requestParameters.iata))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStationsApiStationsGetByIataCodeIataGet(requestParameters: ApiStationsApiStationsGetByIataCodeIataGetRequest): Promise<void> {
        await this.apiStationsApiStationsGetByIataCodeIataGetRaw(requestParameters);
    }

    /**
     */
    async apiStationsBulkUploadStationsPostRaw(): Promise<runtime.ApiResponse<UploadStationsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations/BulkUploadStations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadStationsResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiStationsBulkUploadStationsPost(): Promise<UploadStationsResponse> {
        const response = await this.apiStationsBulkUploadStationsPostRaw();
        return await response.value();
    }

    /**
     */
    async apiStationsGetAllStationsGetRaw(requestParameters: ApiStationsGetAllStationsGetRequest): Promise<runtime.ApiResponse<StationListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.iataCode !== undefined) {
            queryParameters['iataCode'] = requestParameters.iataCode;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.locationCode !== undefined) {
            queryParameters['locationCode'] = requestParameters.locationCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations/GetAllStations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StationListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiStationsGetAllStationsGet(requestParameters: ApiStationsGetAllStationsGetRequest): Promise<StationListBusinessDataResponse> {
        const response = await this.apiStationsGetAllStationsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiStationsGetConfigurationGetRaw(): Promise<runtime.ApiResponse<StationsControllerConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations/GetConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StationsControllerConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiStationsGetConfigurationGet(): Promise<StationsControllerConfiguration> {
        const response = await this.apiStationsGetConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiStationsIdGetRaw(requestParameters: ApiStationsIdGetRequest): Promise<runtime.ApiResponse<StationListBusinessDataResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStationsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StationListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiStationsIdGet(requestParameters: ApiStationsIdGetRequest): Promise<StationListBusinessDataResponse> {
        const response = await this.apiStationsIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiStationsPatchRaw(requestParameters: ApiStationsPatchRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StationToJSON(requestParameters.station),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStationsPatch(requestParameters: ApiStationsPatchRequest): Promise<void> {
        await this.apiStationsPatchRaw(requestParameters);
    }

    /**
     */
    async apiStationsPostRaw(requestParameters: ApiStationsPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationToJSON(requestParameters.station),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiStationsPost(requestParameters: ApiStationsPostRequest): Promise<string> {
        const response = await this.apiStationsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiStationsValidatePostRaw(requestParameters: ApiStationsValidatePostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Stations/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationToJSON(requestParameters.station),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiStationsValidatePost(requestParameters: ApiStationsValidatePostRequest): Promise<ValidationErrors> {
        const response = await this.apiStationsValidatePostRaw(requestParameters);
        return await response.value();
    }

}
